import React from 'react';
import { MARKET_PRICES } from '../constants/pricing';

const NeuronDetailsModal = ({ isOpen, onClose, neuronData }) => {
  if (!isOpen || !neuronData) return null;

  return (
    <div className="modal-overlay">
      <div className="neuron-details-modal">
        <div className="modal-header">
          <h2 className="modal-title">Neuron Details</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Status Overview */}
          <div className="status-overview">
            <div className="status-icon">🔄</div>
            <div className="status-info">
              <h3>Withdrawal Request #{neuronData.id}</h3>
              <span className="status-badge waiting">{neuronData.status}</span>
            </div>
          </div>

          {/* Transaction Details */}
          <div className="details-section">
            <h4>Transaction Details</h4>
            <div className="detail-grid">
              <div className="detail-item">
                <label>nICP Burned</label>
                <div className="detail-value">
                  <span className="amount">{neuronData.nIcpBurned.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                  <span className="usd-value">${(neuronData.nIcpBurned * MARKET_PRICES.nICP).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
              </div>
              
              <div className="detail-item">
                <label>ICP Due</label>
                <div className="detail-value">
                  <span className="amount">{neuronData.icpDue.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                  <span className="usd-value">${(neuronData.icpDue * MARKET_PRICES.ICP).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Neuron Information */}
          <div className="details-section">
            <h4>Neuron Information</h4>
            <div className="detail-grid">
              <div className="detail-item full-width">
                <label>Neuron ID</label>
                <div className="neuron-id-display">
                  <span className="neuron-id">{neuronData.neuronId}</span>
                  <button className="copy-button" onClick={() => navigator.clipboard.writeText(neuronData.neuronId)}>
                    📋
                  </button>
                </div>
              </div>
              
              <div className="detail-item">
                <label>Request ID</label>
                <span className="request-id">{neuronData.id}</span>
              </div>
              
              <div className="detail-item">
                <label>Estimated Completion</label>
                <span className="completion-date">~6 months</span>
              </div>
            </div>
          </div>

          {/* Progress Information */}
          <div className="details-section">
            <h4>Progress</h4>
            <div className="progress-info">
              <div className="progress-item">
                <span className="progress-label">Status:</span>
                <span className="progress-value">Waiting for dissolvement to complete</span>
              </div>
              <div className="progress-item">
                <span className="progress-label">Next Update:</span>
                <span className="progress-value">Check back in a few days</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button 
            className="action-button secondary"
            onClick={onClose}
          >
            Close
          </button>
          <button 
            className="action-button danger"
            onClick={() => {
              alert(`Cancel withdrawal request #${neuronData.id}?`);
              onClose();
            }}
          >
            Cancel Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default NeuronDetailsModal;
